import { ref, watch, onMounted } from 'vue'

export function useDarkMode() {
  const isDark = ref(false)

  // Función para cambiar el modo
  const toggleDarkMode = () => {
    isDark.value = !isDark.value
    updateTheme()
  }

  // Función para actualizar el tema en el DOM
  const updateTheme = () => {
    if (isDark.value) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('darkMode', 'true')
    } else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('darkMode', 'false')
    }
  }

  // Función para establecer el modo oscuro
  const setDarkMode = (dark) => {
    isDark.value = dark
    updateTheme()
  }

  // Inicializar el tema al montar el componente
  onMounted(() => {
    const savedMode = localStorage.getItem('darkMode')
    if (savedMode !== null) {
      isDark.value = savedMode === 'true'
    } else {
      // Detectar preferencia del sistema si no hay preferencia guardada
      isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches
    }
    updateTheme()
  })

  // Observar cambios en la preferencia del sistema
  watch(isDark, updateTheme)

  return {
    isDark,
    toggleDarkMode,
    setDarkMode
  }
} 